import './index.scss';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Provider as DsxProvider, defaultTheme } from '@dsx/react';
import App from './App';
import { store } from './app/store';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <DsxProvider theme={defaultTheme} locale="en-US">
        <App />
      </DsxProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);
